/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { dataFormatRO } from '../../../../utils/functiiComune';
import { t } from '../../../../i18n';


// Create styles
const styles = StyleSheet.create({
  section: {
    margin: 10,
    padding: 10,
    display:'flex',
    flexDirection: 'column',
  },
  denumireFirma:{
    marginTop: 25,
    marginLeft:25,
    marginBottom:0,
  },
  linie:{
    marginTop:-15,
    marginLeft:25,
    padding:0,
  },
  dateFirma:{
    marginTop: 0,
    marginLeft:25,
    fontSize:10,
  },

  titlu:{
    marginTop: 25,
    marginLeft:25,
    marginBottom:25,
    textAlign:'center',
    fontWeight:'900'
  },
  dateComanda:{
    marginTop: 0,
    marginLeft:25,
    marginBottom:0,
    fontSize:12,
    
  }
});

// Create Document Component
const Header = (props) => {
  return(
    <View style={styles.section}>
      <Text style={styles.denumireFirma}>{props.currentUser.idFirma.denumire}</Text>
      <Text style={styles.linie}>____________________________________________________________________________</Text>
      <Text style={styles.dateFirma}>{`${t('pdf.header.taxCode')}:${props.currentUser.idFirma.atributCodFiscal===null?'':props.currentUser.idFirma.atributCodFiscal}${props.currentUser.idFirma.codFiscal}`}</Text>
      <Text style={styles.dateFirma}>{`${t('pdf.header.tradeRegister')}:${props.currentUser.idFirma.regCom}`}</Text>
      <Text style={styles.dateFirma}>{`${t('pdf.header.address')}:${props.currentUser.idFirma.oras}, ${props.currentUser.idFirma.adresa}`}</Text>
      <Text style={styles.dateFirma}>{`${t('pdf.header.phone')}:${props.currentUser.idFirma.telefon}`}</Text>
      <Text style={styles.dateFirma}>{`${t('pdf.header.email')}:${props.currentUser.idFirma.email}`}</Text>

      <Text style={styles.titlu}>{t('pdf.header.offerTitle', { product: props.currentProduct.title.toUpperCase() })}</Text>
      

      <Text style={styles.dateComanda}>{`${t('pdf.header.number')}: ${props.currentOrder.id}     ${t('pdf.header.date')}: ${dataFormatRO(props.currentOrder.dataComanda)}`}</Text>
      <Text style={styles.dateComanda}>{`${t('pdf.header.client')}: ${props.currentOrder.clientClient}`}</Text>
      <Text style={styles.dateComanda}>{`${t('pdf.header.observations')}: ${props.currentOrder.observatii}`}</Text>

    </View>
  )
};

export default Header